import { ALL_UPLOAD_BUCKETS } from "./borrowerUploadConfig.js";

export function isValidEmail(value) {
  const v = String(value || "").trim();
  if (!v) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

export function isNonNegativeNumber(value) {
  if (value === "" || value === null || value === undefined) return false;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0;
}

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function touchErrors(fields, values, rules) {
  const errors = {};
  Object.keys(rules).forEach((key) => {
    const msg = rules[key](values[key], values);
    if (msg) errors[key] = msg;
  });
  return errors;
}

export function hasErrors(errors) {
  return Object.keys(errors).length > 0;
}

/** Build upload key → title map for review */
export function buildUploadLabelMap(buckets = ALL_UPLOAD_BUCKETS) {
  const map = {};
  buckets.forEach((b) => {
    map[b.key] = b.title;
  });
  return map;
}
